import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { partnersData } from '../mock';

const Partners = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Tərəfdaşlarımız
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Beynəlxalq brendlərlə əməkdaşlıq
          </p>
        </div>

        {/* Partners Grid */}
        <div className="flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-8 max-w-4xl">
            {partnersData.map((partner, index) => (
              <Card
                key={partner.id}
                className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-gray-100 hover:border-green-400 bg-white"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <CardContent className="pt-8 pb-8">
                  {/* Logo */}
                  <div className="flex justify-center mb-6">
                    <div className="w-full h-32 flex items-center justify-center p-4">
                      <img
                        src={partner.logo}
                        alt={partner.name}
                        className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                  </div>

                  {/* Partner Info */}
                  <div className="text-center">
                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-green-600 transition-colors duration-200">
                      {partner.name}
                    </h3>
                    <p className="text-gray-600 mb-4">{partner.description}</p>

                    {/* Website Link */}
                    {partner.website && (
                      <a
                        href={partner.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-green-600 hover:text-green-700 font-medium transition-colors duration-200"
                      >
                        Veb sayt
                        <ExternalLink className="ml-1" size={16} />
                      </a>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
